<div #container class="data-table-container">
  <ng-content select="filter"></ng-content>
  <ng-content select="action-buttons"></ng-content>
  @if (items) {
    <div class="data-table" [class.bottom-padding]="!filter || !maxItemCount">
      @if (isHeaderVisible()) {
        <app-header
          [filter]="filter"
          [columns]="columns"
          (sortEvent)="changeSort($any($event))"
          (toggleAll)="changeToggleAll($any($event))"
          (toggleCurrentPage)="changeToggleCurrentPage($event)"
        ></app-header>
      }
      @if (items.length) {
        @if (isCardView()) {
          <app-card-view
            class="body"
            [items]="items"
            [columns]="columns"
            [sortedField]="filter?.sort?.field"
            [hasNavigation]="hasNavigation"
            (rowClick)="rowClick($any($event))"
          >
          </app-card-view>
        }
        @if (isListView()) {
          <app-list-view
            class="body"
            [items]="items"
            [columns]="columns"
            [sortedField]="filter?.sort?.field"
            [hasNavigation]="hasNavigation"
            (rowClick)="rowClick($any($event))"
          >
          </app-list-view>
        }
      }
      @if (!items.length) {
        <div class="body">
          @if (!items.length) {
            <div class="placeholder">No results found with the provided criteria</div>
          }
        </div>
      }
      @if (filter && maxItemCount) {
        <app-data-table-paginator [maxItemCount]="maxItemCount" [filter]="filter" (onPageChange)="pageChanged()"></app-data-table-paginator>
      }
    </div>
  }
</div>
